<mat-progress-bar data-testId="loading-indicator" mode="indeterminate"></mat-progress-bar>